import { DateTime } from "luxon"
import axios from "axios"
import { toastr } from "../ui/toastr/toastrService"
import { isReactive, isRef, ref, toRaw, unref, watch, type Ref } from "vue";
import type { ChqApiError } from "./global-types";

type DateFormat = 'default' | 'medium' | 'short' | 'fullDate' | 'longDate' | 'mediumDate' | 'shortDate' | 'mediumTime' | 'shortTime' | 'sql'

export const defaultHeaders = { headers: { 'Content-Type': 'application/json' } }
export const newMessageSound = new Audio("data:audio/mpeg;base64,SUQzBAAAAAAAI1RTU0UAAAAPAAADTGF2ZjU5LjI3LjEwMAAAAAAAAAAAAAAA//uQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAASW5mbwAAAA8AAAAJAAAQUgAzMzMzMzMzMzMzM0xMTExMTExMTExMZmZmZmZmZmZmZmZ/f39/f39/f39/f5mZmZmZmZmZmZmZs7Ozs7Ozs7Ozs7PMzMzMzMzMzMzMzObm5ubm5ubm5ubm//////////////8AAAAATGF2YzU5LjM3AAAAAAAAAAAAAAAAJAQ6AAAAAAAAEFIKahV1AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA//uQZAAA8pZks8hAOvoAAA0gAAABD0mc8TSEAAAAADSCgAAEAuAACcn/ZxhB/9m//1djHVB0eGolBgHAjlDTjTiLkzD0VB0bDAsG44qGnM55h6dKK7b////9GZ2PT/qg6XF40H0U5nMQ1yB44JxUMBII5QGFqlgAIMMAAHw7Be76UHYf3P///z+ieif//3OlPH//yW/X//+knuL2kpltTi7VX+gorB+DcIyDTxABoDQA4gCofhwo8s4F4KwA5y2NBucLnv6BwIjye9/jBQeKU9+ici9pLClculZAoZBn/oQDcXv/l6LFw/H8sZAcDrxc+7tHNyc2QA0NYfjBLNP//j7r+Q0WXUu50yDVYznpviCBBhmDW2tadjoggQ8R+RUi6+pZs+cOkQDLY00BxBqhSKjdpfSLg7TUqScJwXOF0wDg4LAQbB4YnlY0KBNk2xXKRWRI4lybTIoywABAGKAA2oB3XoG3ggbUGB9a4LRwMICSm5+sydUyL63PqNEzdRgTYHdVhx4ssQqBhQ4Cg8BQGOInAbbhic1WxkaVa1OZqQK5//uSZFgABuCCwQZigAAXxLUiwJQAGZ2NR7mHgBB5CCRjDiAAmgXDXJOZlE0QKZYIsJ0DLgjwUARUcYuMmxzw+cQuNoQnDp3////6H////J8IMIAAD/7+/f/////OgoOf/8OAh0u/LjthsLlsdjufVoaiwITERIj2CTWCJqpdyrTaF+F0L8y3K6jJ2IWyaDQSTFa6hw7KAxGbczzKMIhPKdCEZCVDqAwI408y2VERTzqxLsCHs7CnDSdwVQxragbLueo8dveLTtRqUymHzvPHuyTucsae+XivYskvBGAc5JzGiQGBXqxhjWoytrs/EWTI6k4lFEX9keKlTKqHp2u9QqUjzvM6haXFMOliJhwZdaV/YLvGRgaas94VNvKPJ8P8zxswMfESV5Exe1HkeU2Gmf///+xQAAABAABAHg+Ap2B+A/zyfnP73BO8P/KFy/5sp/oQAd8+2ls2YVpj0gBgaMND0aNpr9uGFnaY/zh8xrGoGIft5pisEBwBBQYBA0MAhALhEEAPqNCwJCWMfIOwBqJSQVRF9HpSotwOtCwaKLOMTf/7kmQngIZjX1XvceAALGEJg+wIABApCVOuDZcIp4Ll3YRoCEuJhC5Ks/ScqhDTRYDmVVz9WWI/Swj6Mo0iQl5il2JLIhxOkyaJopA0oLw5nKpyutvqyYjarLi1aW+Zq/H9PvMd/unu8hsdrSPv4H1fVvuaPa+sb/1W+v8y3ev4U28zRX8TELUmodaT//FNeW8+9TYrmBJP6VgT+XiACRPDIACblBZF1S5yLRiSQoIEhm4mW0gXLPPGoHE7t4aNK9iP281+3/6f+j+hhL+sEAMKt3WIAAhFIRJRSkTgIcxICmHycaZuhp8xAIEJdP7SzrvS6tKbFmvS448psef7OYZcmkzzjjMx2nVYU1qxtk702Q/1/eE135S/56yjlaR8n2horwwaCnSrMErmYK3pzO0puSsibA1I13sQN+ptr/utbDLxUr+KljKufqTyut+MWWEm3GPvkQqhYYixc0ylEyQeNiYtFtqMczv192iqj6d//6UUfq/5n//dBRALtkjRAABzBqyJwU2ldxmWIBTAVY3ZNDBVxmWw9LWnPzfj8StXyir/+5JkFIGEVktUa2hMdivgyUplOAQQXT1NrCGR0KqC5KT0pABOG6qJAAzrKpjdRYzcdb3d3aXmfVVpGtTFOqc9zpaIsTwkLCMg8e8kFZMjB1dk6AMBx4KnGBQIVQ+eI2Mfk6Wl5WtcKtmOKRyMHJ1latoJa6wbzKSbbEl2qnDRBn76p/PEcAAApgEmRw7wttF0CZAExFE7oYtSgUlXYafpBxXs/2dH2/+rezb///+2/f9YQIE2tkSARpGpGkAqZsxBzGszwJQkFZZ0+saZzDFuJUucXE1wUxMSJLW1Kg6rVZ3la4ZrheYaavuyUb1r/j225KvQ7JooeSHqg6wsJyUVAOHEspVB7VaerXWjJk+ZouXH22XLe1x5mj03d6dmflp797NmZnGnrxHEWo9lTMUqFkVHoaPCUGuG0lTQhJRXtkIKnjzBrknF0vKpburV+j9OV/5xdGY2cc31f/sf//WqAQASaXZbYgAADwjhL1wnhZynqB1RYNuD8v/C21tvyDUBUFriBHKD7WTaKbSCx79QNd17a+IUV/2b+Vr//9Vr2Upv//uSZCEBA81STft5QFAzwej4PSMEEHDZFw9xIYDUC2Ro8wwQgpv9V2vKFjpqLDkw2igbB8dK19w1qKmqvZJq17CxzcrCxaqULX/tdflCz+oGsFXLOywFOyzyoKgAAkgAsca2W3B3BbrSa9Kn9003BqPDwUhcr2JJRWTb92pT4tYXexrqEU13zSv/v/Pf/62iAMgA4wBlTBAAYAQbDgIhzMBBw0XAj+OUOaFgLDYIIK+ou+zuqXXbBMgDYbC0lIoSglIrTtBbSBnUpIGl9nbcLm5tX9ErOXRGSJ+JZFj3c+zlXFFkVpN3sXVLKn4Sl6xmPrvMCwXYYBIKMFC14LmCwVSQOsCpO64h/ULt8kA3GE8MRZIALWOhIogCinu7c0Aj9Ptae5IsK5n/GzDDoMYkxIrf1LhwjKO77WfSkzUyIfFNKn//////0zSgKVMKUHYw+DMwRBQBACMggOB6ZIBSedAWBiCCBDIgBDZQjChsULHxEswTFCnO4yDuO0RHmpCgdVRUIGoN4XpqJdpASIT+pfug67YXOLtzjGpxmjWPrenNsf/7kmQtCwQ6Q8SD3UhANUF46CVjGBBY0xSusMsI0IajoLCgAAn0rYn4uYZfrb9n5wV/g755wrValdRzuv1FqF3lSOFqmOUJN2wmsVOew7R25MABYXIAEQt71SYy6vVRkUUEcdEkTyaQogXxXBwmSU4YTNoVJ67Qx5E3lGIqMisbRb/2Wf7ZmR4OIJjWDAOEkOAJPVfQhBMwcQo1BPsiA4aG9RgPiSExdRonlMBMOjpdCTsRLVlE1ICUdkLDgZFBhJ07gCR09CSvg020tNhBr6lZZFj+bbpHHY74jW72c1nvLlBLhj1NxrBLRrIgk7KR/DmH8uzrJz+IBxt/vrJdg3BH/iZfUv/csfmAFRlAAjLCpuGQaKooXrdfU3mlHjyrlspBze4JrPuUlalW0yZozba2onyLrGov/0fp//+9qiwJ7KVVDcNQxQJT6CB0FDadaXhhWYcqgIGtKq6uokrI3MqglFEJeKUaBHn9tbr1m0KZmxaiXLVSBb3Fd1C9Us1Bd45B4FlAyKCV6Ci2rFyNZNZMq5w1l6JJK5q9jZvcmhGm6K//+5JkMgCDRyVHS2ka4DSCiNUkYjwN4NUSrphrgK4IItigiCixzDW+LAIZArbpZ3DYC+fSEsRlZDfU1Nq/BksFx4KAZeavRYyUD1KToqhRK/Mx6xJ/+kx7f/69n/0ABEA6eO8WIxFKnXUIwCHQhMNAVEYANYLxQuCyAdFSJaOJFCQYFN2KOdtxRIDQSY5bNaFT6MTFkGcYUcNjvD/2qyKzGsZjJs7DWLt+KedOqeWNpCoK0eEhKaloCNlskRArrE6gVQNGHiOePRrlij1BoYBQPbDIRuetC/S1WUYSnZpZZsBdtQ556qWKpdtR9v0W6P1s+prur///IxaWkOiwMBoIAwZAJDACAMLUl+2HvtLcrweAolChoqZBYVcmHMJKOh3waPFUR52s6zq4Ku8Sgsjwkegs8jGLO0ByWJYNPKqPFn4alnrLCWo98kuDQAhAUpAAkBXibN0VWoqSSqSdf9hRltGbgolKjAawVTWVO1nvwaVrBU74i4blclh38SnfWdLeGv//6jwAkmGCGGCASuTOC62to6+ASguDfnvfTCRBFMJc//uSZFUAApsFwZV4YAA6ghgKqQwAF0oQ+tnqAAHis5vXOHAADXnP8wJgNigBSrAaYgFL3+AEIAxA4GzPX4GVAgaMeERQBSBVv4GgBAJEgSDgSRg2DPX/HkQRDnhqgLCA+Hq/8LFwCiYbgLHAFCAXzD39T//4Wthlg1GVFTE6BigWaHLqf/f/4NixIA6QCQAPTFjDtiUDEgI3//1///FwB8gxogGFsxQggwMECOxpiTiyDpGj1/////////i4A+QckR+AAIJBAU1qNE9W8Pr6smdN/l6BIAbu/7K6NSWGgknG8SwfjazkfCQAgThO0bHEvgHiILAwNzVLF1X9zix43OITTyQ2M/kBIKkxLHCDUO//yB85jzziHyuON/+QUmTMYsfRvNTN46d//556GEFPJmMx9GHk////4PiBAAEgAAAAAOvc82wMACEisC/5o8TGWT0iq+v+YfHJkAIQKyL/PDUA4PtJ/80ZTTCNZt2YZnP/yTIKAHOQZTNNKq9T//zErDSAWMbNhgr45TO8f//8IIMIURjBUVHIAAyqtfpauH/////7kmQzgAb+aEI2cyAAJiAousMMAAAAAaQcAAAgAAA0g4AABJVEaQHBIJUJqZiZ2VbPWOqv////lqk90fEAqMyN7JkJKf28a2XauPMv/////3gT6UxT1Xot5E5eamiYqq2W9fq7/K2Xf//////9Vd1kxVtPQr5dq0WSNSTmZmuhUq0scedy3r9b/lbXf/////////15wMqVhX/4KmQAEIMMIBQKBgOBwAbcA6cK7Ga0eq34GFv7f+uti/+hSG2/+q1zFkxBTUUzLjEwMKqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqqo=");

export function defer<T>() {
    let resolve!: (value: T) => void;
    let reject!: (reason?: any) => void;

    const createPromise = () => new Promise<T>((res, rej) => {
        resolve = res;
        reject = rej;
    });

    let promise = createPromise();

    return {
        get promise() {
            return promise;
        },
        resolve(value: T) {
            resolve(value);
        },
        reject(reason?: any) {
            reject(reason);
        },
        reset() {
            promise = createPromise();
        }
    };
}

export function useLocalStorage<T>(key: string, defaultValue: T) {
    const stored = localStorage.getItem(key)
    const data = ref<T>(stored ? JSON.parse(stored) : defaultValue)

    watch(data, (newValue) => {
        localStorage.setItem(key, JSON.stringify(newValue))
    }, { deep: true })

    return data
}

export function scrollToTop() {
    document.body.scrollTo({ top: 0, behavior: 'smooth' })
    // document.body.scrollTop = 0; // For Safari
    // document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}

function refreshTabs() {
    window.localStorage.setItem('refreshTabs', Math.random().toString());
}

export function addTabRefreshEvent() {
    window.addEventListener('storage', function (event) {
        if (event.key === 'refreshTabs') {
            window.location.reload();
        }
    });
}

export function changeClinicContext(clinicId: number, redirectUrl?: string, newTab: boolean = false) {
    toastr?.warning('Changing clinic, please wait.');

    axios.get(`/api/account/changeClinicContext/${clinicId}`)
        .then(function () {
            refreshTabs()

            if (redirectUrl) {
                if (newTab) {
                    window.open(redirectUrl, '_blank')
                }
                else {
                    window.location.href = redirectUrl
                }
            }

            window.location.reload()
        })
}

export const today = () => DateTime.local().toFormat('yyyy-MM-dd');
const endOfWeek = () => DateTime.local().endOf('week').toFormat('yyyy-MM-dd');
const getDateOneMonthAgo = () => DateTime.local().minus({ months: 1 }).toFormat('yyyy-MM-dd');
const getStartOfMonth = () => DateTime.local().startOf('month').toFormat('yyyy-MM-dd');

function addDays(days: number, date = new Date()) {
    const d = new Date(date.getTime());
    d.setDate(d.getDate() + days);
    return d;
}

function usaPhone(tel: string) {
    const phoneLength = 10;
    let padding = '';

    for (let i = 0; i < phoneLength; i++) {
        padding += ' ';
    }

    if (!tel) { return ''; }

    //remove empty space and -
    let formated = tel.trim().replace(/ /g, '');
    formated = formated.replace(/-/g, '');

    if (!formated) {
        return '';
    }

    //padd to length of 10
    if (formated.length < 10) {
        formated = (formated + padding).substring(0, 10);
    }

    //format
    return formated.substring(0, 3) + '-' + formated.substring(3, 6) + '-' + formated.substring(6);
}

export function formatDate(input: string | Date, format: DateFormat | (string & {}) = 'default', locale = 'en-US') {
    if (!input) {
        return null;
    }

    const isUTC = typeof input === 'string' && input.endsWith('Z');
    const dt = input instanceof Date
        ? DateTime.fromJSDate(input)
        : DateTime.fromISO(input);

    const u = isUTC ? dt.toUTC() : null;
    const date = u
        ? new Date(u.year, u.month - 1, u.day, u.hour, u.minute, u.second, u.millisecond)
        : dt.toJSDate();

    const predefinedFormats: Record<DateFormat, string> = {
        medium: 'MMM d, y h:mm:ss a',
        short: 'M/d/yyyy h:mm a',
        fullDate: 'EEEE, MMMM d, y',
        longDate: 'MMMM d, y',
        mediumDate: 'MMM d, y',
        shortDate: 'M/d/yyyy',
        default: 'M/d/yyyy',
        mediumTime: 'h:mm:ss a',
        shortTime: 'h:mm a',
        sql: 'yyyy-MM-dd'
    };

    format = predefinedFormats[format] || format;

    const getWeek = (date) => {
        const target = new Date(date.valueOf());
        const dayNr = (date.getDay() + 6) % 7;
        target.setDate(target.getDate() - dayNr + 3);
        const firstThursday = new Date(target.getFullYear(), 0, 4);
        const dayDiff = (target - firstThursday) / 86400000;
        return 1 + Math.floor(dayDiff / 7);
    };

    const pad = (num, len = 2) => String(num).padStart(len, '0');

    const map = {
        yyyy: () => pad(date.getFullYear(), 4),
        yy: () => pad(date.getFullYear() % 100),
        y: () => date.getFullYear(),

        MMMM: () => date.toLocaleString(locale, { month: 'long' }),
        MMM: () => date.toLocaleString(locale, { month: 'short' }),
        MM: () => pad(date.getMonth() + 1),
        M: () => date.getMonth() + 1,
        LLLL: () => date.toLocaleString(locale, { month: 'long' }),

        dd: () => pad(date.getDate()),
        d: () => date.getDate(),

        EEEE: () => date.toLocaleString(locale, { weekday: 'long' }),
        EEE: () => date.toLocaleString(locale, { weekday: 'short' }),

        HH: () => pad(date.getHours()),
        H: () => date.getHours(),

        hh: () => pad(((date.getHours() + 11) % 12) + 1),
        h: () => ((date.getHours() + 11) % 12) + 1,

        mm: () => pad(date.getMinutes()),
        m: () => date.getMinutes(),

        ss: () => pad(date.getSeconds()),
        s: () => date.getSeconds(),

        sss: () => pad(date.getMilliseconds(), 3),

        a: () => date.getHours() < 12 ? 'AM' : 'PM',

        Z: () => {
            const offset = -date.getTimezoneOffset();
            const sign = offset >= 0 ? '+' : '-';
            const absOffset = Math.abs(offset);
            return sign + pad(Math.floor(absOffset / 60)) + pad(absOffset % 60);
        },

        ww: () => pad(getWeek(date)),
        w: () => getWeek(date),

        G: () => date.getFullYear() >= 0 ? 'AD' : 'BC',
        GG: () => date.getFullYear() >= 0 ? 'AD' : 'BC',
        GGG: () => date.getFullYear() >= 0 ? 'AD' : 'BC',
        GGGG: () => date.getFullYear() >= 0 ? 'Anno Domini' : 'Before Christ'
    };

    // Regex to match all tokens (longer tokens first to avoid partial matches)
    const tokenRegex = new RegExp(Object.keys(map).sort((a, b) => b.length - a.length).join('|'), 'g');

    return format.replace(tokenRegex, (match) => {
        const replacer = map[match];
        return typeof replacer === 'function' ? replacer() : match;
    });
}

export function formatCurrency(
    value: number | string,
    currencySymbol: string = '$',
    fractionSize: number = 2,
    locale: string = 'en-US'
): string {
    if (value === null || value === undefined || isNaN(Number(value))) return '';

    const num = Number(value);
    const absFormatted = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: fractionSize,
        maximumFractionDigits: fractionSize,
    }).format(Math.abs(num));

    return (num < 0 ? '-' : '') + absFormatted.replace(/^\D+/, currencySymbol);
}

function formatNumber(value, fractionDigits = 2, locale = 'en-US') {
    if (value === null || value === undefined || value === '') return '';

    const num = Number(value);
    if (!Number.isFinite(num)) return '';

    return num.toLocaleString(locale, {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    });
}

export async function ajaxFileRequest(
    url: string,
    onSuccess?: (blob: Blob, filename: string) => void,
    onError?: (error: ErrorResponse) => void
) {
    try {
        const response = await axios.get(url, {
            responseType: 'blob'
        })

        const filename = getFilenameFromHeader(response.headers['content-disposition'])
        onSuccess?.(response.data, filename)
    } catch (error) {
        if (onError) {
            const message = await extractAxiosErrorMessage(error);
            onError(message);
        }
    }
}

export async function ajaxFileRequestPost(
    url: string,
    payload: any,
    onSuccess?: (blob: Blob, filename: string) => void,
    onError?: (error: ChqApiError) => void
) {
    try {
        const response = await axios.post(url, payload, { responseType: 'blob' })
        const filename = getFilenameFromHeader(response.headers['content-disposition'])
        onSuccess?.(response.data, filename)
    }
    catch (error) {
        if (onError) {
            const message = await extractAxiosErrorMessage(error);
            onError?.(message);
        }
    }
}

async function extractAxiosErrorMessage(error: unknown): Promise<ChqApiError> {

    if (!axios.isAxiosError(error)) return { response: { data: String((error as any)) } };

    const resp = error.response;

    // No response at all (network error / CORS / timeout)
    if (!resp) return { response: { data: error } };

    const data = resp.data;

    try {
        if (data instanceof Blob) {
            const text = await data.text();
            try {
                return { response: { data: JSON.parse(text) } };
            }
            catch {
                return { response: { data: text } };
            }
        }
    } catch { }

    return { response: { data: error } };
}

function getFilenameFromHeader(header: string | null): string {
    if (!header) return 'download'
    const match = header.match(/filename\*?=([^;]+);?/)
    if (match) {
        const value = match[1].trim()
        if (value.startsWith("UTF-8''")) return decodeURIComponent(value.replace("UTF-8''", ''))
        return value.replace(/(^"|"$)/g, '')
    }
    return 'download'
}

export function downloadFile(blob: Blob, fileName: string) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.href = url;
    a.download = fileName;
    a.click();
    a.remove();

    setTimeout(function () {
        window.URL.revokeObjectURL(url);
    }, 1000);
}

export function handleError(error: ChqApiError | { response: { data: any } }, message?: string) {
    if (message) {
        toastr.error(error?.response?.data?.message || message);
        return;
    }

    toastr.error(error?.response?.data?.message || 'Unexpected error occurred. Please try again later.')
}

function showErrorMessage(error) {
    if (!error?.response?.data?.errors) {
        toastr.error('Error occured, please try again later.');
        return;
    }

    const errorsFormated = error.response.data.errors.join('<br/>');
    toastr.error(errorsFormated);
}

export function groupBy<T>(list: T[], key: string) {
    return list.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
}

function groupByOneToOne(list: any[], key: string, otherKey?: string) {
    return list.reduce(function (rv, x) {
        if (!otherKey) {
            rv[x[key]] = x;
            return rv;
        }

        rv[x[key]] = x[otherKey];
        return rv;
    }, {});
}

export function createGroupCount(grouped, groupKey = 'id') {
    const count = {};
    let c = 0

    for (const key of Object.keys(grouped)) {
        count[key] = {};

        for (const group of grouped[key]) {
            count[key][group[groupKey]] = ++c;
        }
    }

    return count;
}

export function highlight(matchItem, query: string) {
    function escapeRegexp(queryToEscape: string) {
        return ('' + queryToEscape).replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
    }

    return query && matchItem ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<span class="ui-select-highlight">$&</span>') : matchItem;
}

export function debounce(func: (...val: any) => void, wait: number, immediate?: boolean) {
    let timeout;
    let result;

    return function (...args) {
        const context = this;
        const later = function () {
            timeout = null;
            if (!immediate) {
                result = func.apply(context, args);
            }
        };

        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);

        if (callNow) {
            result = func.apply(context, args);
        }

        return result;
    };
}

function roundNumber(num: number, decimalPlaces: number) {
    // Implemented as Bankers' Rounding algorithm so it follows C# logic
    // Taken from: https://stackoverflow.com/a/3109234/834942

    const d = decimalPlaces || 0;
    const m = Math.pow(10, d);
    const n = +(d ? num * m : num).toFixed(8); // Avoid rounding errors
    const i = Math.floor(n), f = n - i;
    const e = 1e-8; // Allow for rounding errors in f
    const r = (f > 0.5 - e && f < 0.5 + e)
        ? ((i % 2 === 0) ? i : i + 1)
        : Math.round(n);
    return d ? r / m : r;
}

function focusElement(elementId: string) {
    if (!elementId) return;
    setTimeout(function () {
        const elmToFocus = window.document.getElementById(elementId);

        if (elmToFocus) {
            elmToFocus.focus({ preventScroll: false });
        }
    }, 200);
}

function calculateTax(price: number, taxValue: number) {
    if (!taxValue) return 0;

    return roundNumber(taxValue / 100 * price, 4);
}

function getLang() {
    return (navigator.languages && navigator.languages.length) ? navigator.languages[0] : navigator.language;
}

function getPhoneMask() {
    const lang = getLang()

    switch (lang) {
        case 'en_NZ':
            return '99-999 9999'
        default:
            return '999-999-9999'
    }
}

function getCreditCardFlags() {
    return [
        "MasterCard",
        "Visa",
        "American Express",
        "Discover",
        "Diners Club",
        "CreditCare",
        "PayPal",
        "Debit",
        "Gift Card",
        "EFT",
        "Other",
        "Financed"
    ];
}

// size in bytes
function toFileSize(size) {
    if (size === 0) {
        return '0B';
    }

    if (size < 1000) {
        return '1KB';
    }

    const newSize = Math.round(size / 1024);

    if (newSize < 1024) {
        return newSize + 'KB';
    }

    return Math.round(newSize / 1024) + 'MB';
}

function toOrdinal(value) {
    const j = value % 10,
        k = value % 100;
    if (j == 1 && k != 11) {
        return value + "st";
    }
    if (j == 2 && k != 12) {
        return value + "nd";
    }
    if (j == 3 && k != 13) {
        return value + "rd";
    }
    return value + "th";
}

function initItemForm(items: any[], form: Ref<any, any>, key: string) {
    for (const item of items) {
        if (!Object.keys(form.value).includes(item[key] + "")) {
            form.value[item[key] + ""] = {}
        }
    }
}

function select2Matcher(term: string, data: string) {
    // If there are no search terms, return all of the data
    if (!term || term.trim() === '') {
        return data;
    }

    if (data.toLowerCase().includes(term.trim().toLowerCase())) {
        return data;
    }

    // Return `null` if the term should not be displayed
    return null;
}

function deepClone(val) {
    return JSON.parse(JSON.stringify(val));
}

function objectToFormData(obj, form = new FormData(), namespace = '') {
    const data = isRef(obj) ? unref(obj)
        : isReactive(obj) ? toRaw(obj)
            : obj

    for (const key in data) {
        if (!Object.prototype.hasOwnProperty.call(data, key)) continue
        const value = data[key]
        const formKey = namespace ? `${namespace}[${key}]` : key

        if (value instanceof File) {
            form.append(formKey, value)
        } else if (Array.isArray(value)) {
            value.forEach((v, i) => {
                objectToFormData(v, form, `${formKey}[${i}]`)
            })
        } else if (value !== null && typeof value === 'object') {
            objectToFormData(value, form, formKey)
        } else {
            form.append(formKey, value == null ? '' : value)
        }
    }

    return form
}

export function generatePattern(data: { gaps: number[], lengths: number[] }, char = '#', space = ' ') {
    return data.lengths.map((len, idx) => {
        const gap = data.gaps[idx];
        let pattern = '';
        for (let i = 1; i <= len; i++) {
            pattern += char;
            if (i % gap === 0 && i < len) {
                pattern += space;
            }
        }
        return pattern;
    });
}

export function getRandomUUID() {
    if (typeof globalThis !== 'undefined' &&
        globalThis.crypto &&
        typeof globalThis.crypto.randomUUID === 'function') {
        return globalThis.crypto.randomUUID();
    }

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

export function broadcastEvent(eventId: string) {
    document.dispatchEvent(new CustomEvent(eventId));
}

function pickColor(bgColor) {
    if (bgColor == null) {
        return '#000';
    }

    const color = (bgColor.charAt(0) === '#') ? bgColor.substring(1, 7) : bgColor;
    const r = parseInt(color.substring(0, 2), 16);
    const g = parseInt(color.substring(2, 4), 16);
    const b = parseInt(color.substring(4, 6), 16);
    return (((r * 0.299) + (g * 0.587) + (b * 0.114)) > 186) ?
        '#000' : '#fff';
}

function colorOpacity(bgColor) {
    if (bgColor == null) {
        return '#fff';
    }

    const color = (bgColor.charAt(0) === '#') ? bgColor.substring(1, 7) : bgColor;
    const r = parseInt(color.substring(0, 2), 16);
    const g = parseInt(color.substring(2, 4), 16);
    const b = parseInt(color.substring(4, 6), 16);

    return `rgba(${r},${g},${b},0.35)`;
}

function dictToArray(field) {
    if (field == null) {
        return null;
    }

    const arr = [];
    for (const id in field) {
        if (!field[id]) {
            continue;
        }
        arr.push(+id);
    }
    return arr;
}

export default {
    defer,
    scrollToTop,
    downloadFile,
    calculateTax,
    handleError,
    dictToArray,
    showErrorMessage,
    useLocalStorage,
    ajaxFileRequest,
    ajaxFileRequestPost,
    changeClinicContext,
    addTabRefreshEvent,
    getCreditCardFlags,
    createGroupCount,
    groupByOneToOne,
    newMessageSound,
    defaultHeaders,
    formatCurrency,
    formatNumber,
    focusElement,
    getPhoneMask,
    roundNumber,
    formatDate,
    endOfWeek,
    highlight,
    deepClone,
    debounce,
    usaPhone,
    getLang,
    groupBy,
    today,
    addDays,
    refreshTabs,
    getDateOneMonthAgo,
    getStartOfMonth,
    toFileSize,
    toOrdinal,
    initItemForm,
    select2Matcher,
    objectToFormData,
    generatePattern,
    getRandomUUID,
    broadcastEvent,
    pickColor,
    colorOpacity
}
